// Omgevingen, eigen thema en agendaverbindingen (Frans). Zelfde vorm als omgevingApp.nl.ts.
// Vaste smalle spatie (U+202F) voor : ; ? ! zoals in de rest van de Franse catalogus.
export const appOmgevingFr = {
    spaces: {
        mine: 'Mon espace',
        switchLabel: 'Changer d’espace',
        choose: 'Choisir un espace',
        private: 'Privé',
        shared: 'Partagé',
        dialogTitle: 'Choisissez votre espace',
        dialogBody: 'Planifiez pour vous-même ou avec d’autres.',
        close: 'Fermer',
        current: 'Espace actuel',
        privateHint: 'Privé · rien que pour vous',
        sharedHint: 'Partagé · planifier ensemble',
        opening: 'Ouverture de l’espace…',
        failed: 'Le changement n’a pas fonctionné. Réessayez.',
        personalNotice: 'Mon espace · privé : ce planning et ces données sont rien que pour vous. Passez à Partagé en haut pour planifier ensemble.',
    },
    personalTheme: {
        title: 'Mon thème',
        body: 'Choisissez l’apparence de votre application. Ce choix est enregistré dans votre compte et s’applique sur tous vos appareils. Le tableau partagé et les autres utilisateurs gardent leur propre thème.',
        auto: 'Suivre le thème de mon foyer',
        warm: 'Chaleureux et ludique',
        calm: 'Doux et calme',
        minimal: 'Minimaliste',
        graphic: 'Net et graphique',
        contrast: 'Grand et contrasté',
        failed: 'Votre thème n’a pas pu être chargé.',
        retry: 'Réessayer',
        saved: 'Votre thème est enregistré.',
    },
    calendarSync: {
        title: 'Mes connexions d’agenda',
        intro: 'Connectez votre agenda principal Google ou Microsoft à {name}. Vous seul gérez cette connexion. Dans cet espace, les droits d’accès habituels s’appliquent aux rendez-vous importés.',
        details: 'Automatiquement toutes les cinq minutes, de 30 jours en arrière à un an à l’avance. Les répétitions sont synchronisées comme des rendez-vous séparés. Seuls le titre, les horaires, le lieu et les notes sont échangés, pas de participants ni d’invitations. Modifiez les réunions avec participants dans Google ou Outlook.',
        connected: 'Agenda connecté. Choisissez Synchroniser maintenant pour commencer tout de suite.',
        failed: 'La connexion a échoué ou a été annulée. Réessayez.',
        retry: 'Réessayer',
        provider: 'Service d’agenda',
        google: 'Google Agenda / Gmail',
        googleShort: 'Google Agenda',
        microsoft: 'Microsoft 365 / Outlook',
        direction: 'Sens de synchronisation',
        import: 'Uniquement vers AMUMIN',
        export: 'Uniquement depuis AMUMIN',
        both: 'Dans les deux sens',
        scope: 'Quels rendez-vous envoyer ?',
        scopeMine: 'Les rendez-vous auxquels je participe',
        scopeAll: 'Tous les rendez-vous de cet espace',
        notConfigured: 'Ce service d’agenda doit encore être activé par AMUMIN. Les abonnements d’agenda existants restent disponibles.',
        alreadyConnected: 'Déjà connecté',
        connect: 'Connecter l’agenda',
        lastSync: 'Dernière synchronisation : {when}',
        neverSynced: 'Pas encore synchronisé',
        conflicts: {
            one: '{count} rendez-vous a été modifié ou supprimé des deux côtés. Il a été conservé. Vérifiez les deux agendas et choisissez la version à garder.',
            other: '{count} rendez-vous ont été modifiés ou supprimés des deux côtés. Ils ont été conservés. Vérifiez les deux agendas et choisissez la version à garder.',
        },
        synced: 'Synchronisation effectuée.',
        syncNow: 'Synchroniser maintenant',
        keepLocal: 'Garder les versions AMUMIN',
        keepRemote: 'Garder les versions externes',
        disconnect: 'Arrêter la connexion',
        disconnectHint: 'Arrêter ne supprime aucun rendez-vous. Pour changer de sens, arrêtez la connexion puis reconnectez-vous.',
        personalLinks: 'Votre agenda personnel reste privé. Créez les liens d’abonnement partagés depuis votre espace partagé.',
    },
    errors: {
        personalSpacePrivate: 'Votre espace personnel est rien que pour vous. Passez à Partagé pour inviter des personnes ou connecter un tableau.',
        providerNotConfigured: 'Ce service d’agenda n’est pas encore activé par AMUMIN.',
        alreadyConnected: 'Ce service d’agenda est déjà connecté. Arrêtez d’abord la connexion existante pour vous reconnecter.',
    },
    rideOpen: {
        dropoff: 'Qui emmène {names} à {title} ?',
        dropoffNoNames: 'Qui emmène à {title} ?',
        pickup: 'Qui va chercher {names} à {title} ?',
        pickupNoNames: 'Qui va chercher à {title} ?',
    },
    notMeHint: '{link} : utilisez le lien en bas de l’e-mail.',
    ingredientsPlaceholder: '500 g de viande hachée\n1 oignon\n1 boîte de tomates',
};
//# sourceMappingURL=omgevingApp.fr.js.map